var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useMemo, useState } from 'react';
import ReactSelect from 'react-select';
import { TextField } from '@mui/material';
import { DUMMY_FUNCTION, SML_SIZE } from '../../constants/common';
import { COUNTRY_DIAL_CODES } from '../../constants/countryCodes';
import { reactSelectStyles } from '../../helpers';
import RffInputWrapper from './RffInputWrapper';
var RffPhoneField = function (_a) {
    var _b, _c;
    var editable = _a.editable, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.label, label = _e === void 0 ? '' : _e, externalLabel = _a.externalLabel, _f = _a.size, size = _f === void 0 ? SML_SIZE.S : _f, placeholder = _a.placeholder, _g = _a.rffInput, rffInput = _g === void 0 ? {
        onChange: function (value) { },
        value: null,
        name: '',
        onBlur: DUMMY_FUNCTION,
        onFocus: DUMMY_FUNCTION
    } : _g, _h = _a.rffMeta, rffMeta = _h === void 0 ? { touched: false, error: '' } : _h, _j = _a.required, required = _j === void 0 ? false : _j, helpText = _a.helpText, errorData = _a.errorData;
    var _k = __read(useState({
        code: { label: 'India', value: '+91', code: 'IN' },
        phone: ''
    }), 2), state = _k[0], setState = _k[1];
    useEffect(function () {
        var _a, _b;
        (_a = rffInput === null || rffInput === void 0 ? void 0 : rffInput.onChange) === null || _a === void 0 ? void 0 : _a.call(rffInput, { phone: state.phone, code: (_b = state.code) === null || _b === void 0 ? void 0 : _b.value });
    }, [state]);
    var handleCountryCodeChange = function (value) {
        setState(__assign(__assign({}, state), { code: value }));
    };
    var handlePhoneChange = function (event) {
        setState(__assign(__assign({}, state), { phone: event.target.value }));
    };
    var handleErrorCta = function () {
        var _a, _b;
        ((_a = errorData === null || errorData === void 0 ? void 0 : errorData.data) === null || _a === void 0 ? void 0 : _a.url) && window.open((_b = errorData === null || errorData === void 0 ? void 0 : errorData.data) === null || _b === void 0 ? void 0 : _b.url, '_blank');
    };
    var filterCountryCodeOptions = function (option, input) { var _a, _b; return ((_b = (_a = option === null || option === void 0 ? void 0 : option.data) === null || _a === void 0 ? void 0 : _a.label) === null || _b === void 0 ? void 0 : _b.toUpperCase().includes(input.toUpperCase())) || option.value.includes(input); };
    var formatCountryCodeOption = function (option, meta) { return (React.createElement(React.Fragment, null,
        option.value,
        meta.context === 'menu' && " ".concat(option.label))); };
    var countryCodeStyle = useMemo(function () { return (__assign(__assign({}, reactSelectStyles(size)), { menu: function (base) { return (__assign(__assign({}, base), { width: '240px' })); } })); }, [size]);
    var getCountryCodeLabel = function (v) { return v.value; };
    var handleOnWheel = function (event) {
        var _a, _b;
        event === null || event === void 0 ? void 0 : event.preventDefault();
        (_b = (_a = event === null || event === void 0 ? void 0 : event.currentTarget) === null || _a === void 0 ? void 0 : _a.blur) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    return (React.createElement(RffInputWrapper, { className: className, editable: editable, label: label, size: size, errorData: errorData, helpText: helpText, rffMeta: rffMeta, externalLabel: externalLabel, required: required, handleErrorCta: handleErrorCta, displayValue: "".concat(((_b = state.code) === null || _b === void 0 ? void 0 : _b.value) ? ((_c = state.code) === null || _c === void 0 ? void 0 : _c.value) + '-' : '').concat(state.phone) },
        React.createElement("div", { className: "lfc-w-full lfc-flex" },
            React.createElement(ReactSelect, __assign({}, rffInput, { options: COUNTRY_DIAL_CODES, getOptionLabel: getCountryCodeLabel, styles: countryCodeStyle, placeholder: "+91", formatOptionLabel: formatCountryCodeOption, filterOption: filterCountryCodeOptions, value: state.code, onChange: handleCountryCodeChange })),
            React.createElement(TextField, __assign({}, rffInput, { label: externalLabel ? undefined : label, className: "lfc-flex-grow-[2]", variant: "outlined", size: size, placeholder: placeholder, type: "number", value: state.phone, onChange: handlePhoneChange, inputProps: {
                    onWheel: handleOnWheel
                } })))));
};
export default RffPhoneField;
//# sourceMappingURL=RffPhoneField.js.map